export default function FreeInspections() {
  const inspectionSteps = [
    {
      number: '01',
      title: 'Schedule Your Inspection',
      description: 'Contact us to set up a convenient time for your free roof inspection.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '02',
      title: 'Comprehensive Evaluation',
      description: 'Our certified inspectors examine every aspect of your roof with detailed photo documentation.',
      icon: 'ri-search-line'
    },
    {
      number: '03',
      title: 'Detailed Report',
      description: 'Receive a written assessment with photos, condition ratings, and repair recommendations.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '04',
      title: 'Free Estimate',
      description: 'Get a transparent, no-obligation quote for any recommended repairs or replacements.',
      icon: 'ri-money-dollar-circle-line'
    }
  ];

  const benefits = [
    'No obligation or pressure',
    'Certified inspectors',
    'Photo documentation',
    'Written condition report',
    'Repair recommendations',
    'Free cost estimates'
  ];

  return (
    <section id="inspections" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-green-100 text-green-600 text-xs font-bold uppercase tracking-wider mb-4">
            FREE INSPECTIONS
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Know Your Roof&apos;s Condition
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Regular roof inspections can prevent costly repairs and extend your roof&apos;s lifespan. We provide comprehensive evaluations at no cost to help you make informed decisions about your roof.
          </p>
        </div>

        {/* Inspection Process */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {inspectionSteps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < inspectionSteps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-green-300 to-transparent -ml-4"></div>
              )}

              <div className="relative bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border-2 border-gray-200 hover:border-green-400 hover:shadow-xl transition-all duration-300">
                {/* Number Badge */}
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mb-4 mt-4">
                  <i className={`${step.icon} text-green-600 text-2xl`}></i>
                </div>

                {/* Content */}
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Benefits Section */}
        <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-3xl p-10 md:p-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                What&apos;s Included in Your Free Inspection
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <span className="text-sm font-medium text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
              <a
                href="#contact"
                className="inline-flex items-center px-8 py-4 bg-green-600 text-white text-base font-semibold rounded-full hover:bg-green-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Schedule Free Inspection
                <i className="ri-arrow-right-line ml-3 text-xl"></i>
              </a>
            </div>

            {/* Right Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/911bdb6ac88a25fa728472ecb07ac70f.jpg"
                  alt="Professional Roof Inspection"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-2xl p-5">
                <div className="flex items-center">
                  <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-price-tag-3-line text-green-600 text-2xl"></i>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">$0</div>
                    <div className="text-sm text-gray-600">Inspection Cost</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}